!function(){
  var global = (typeof globalThis !== 'undefined') ? globalThis : window;
  var origFetch = global.fetch;
  function match(url){
    try {
      url = String(url instanceof Request ? url.url : url || '');
      if (/^https:\/\/ipinfo\.io\/json:?$/i.test(url)) return 'ipinfo';
      if (/^https:\/\/justone\.ai\/v1\/public\/subdomain\/landmarkathletics\.myshopify\.com$/i.test(url)) return 'justone';
      return '';
    } catch(_) { return ''; }
  }
  function stubResponse(kind){
    if (kind === 'ipinfo') {
      var body = '{"ip":"","city":"","region":"","country":"US"}';
      return new Response(body, { status: 200, headers: { 'Content-Type': 'application/json' } });
    }
    if (kind === 'justone') {
      var body = '{"accountID":"","domainID":"ac057489e6f64056a1ac27047fae0a38","subDomainID":"","createdAt":null,"updatedAt":null,"hostName":"","hostNameID":"","nameStatus":0,"certStatus":0,"validationID":"","validationBody":"","validationURL":""}';
      return new Response(body, { status: 200, headers: { 'Content-Type': 'application/json' } });
    }
    return new Response('', { status: 200 });
  }
  function patchedFetch(){
    var url = arguments[0];
    var kind = match(url);
    if (kind) return Promise.resolve(stubResponse(kind));
    return origFetch.apply(this, arguments);
  }
  try { global.fetch = patchedFetch; } catch(_){}
  try { window.fetch = patchedFetch; } catch(_){}
  try { self.fetch = patchedFetch; } catch(_){}
  // Attempt to patch same-origin iframes
  function patchFrames(){
    var iframes = document.querySelectorAll('iframe');
    for (var i=0;i<iframes.length;i++){
      var f = iframes[i];
      try {
        var w = f.contentWindow;
        if (w && w.fetch && w.location && w.location.origin === window.location.origin){
          w.fetch = patchedFetch;
        }
      } catch(_){}
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchFrames, { once: true });
  } else {
    patchFrames();
  }
  // Minimal XHR interception for targeted endpoints
  var OrigXHR = window.XMLHttpRequest;
  function FakeXHR(){
    this.readyState = 0;
    this.status = 0;
    this.responseText = '';
    this.response = '';
    this.onreadystatechange = null;
    this.onload = null;
    this._url = '';
    this._method = 'GET';
  }
  FakeXHR.prototype.open = function(method, url){
    this._method = method;
    this._url = url;
    this.readyState = 1;
    if (typeof this.onreadystatechange === 'function') this.onreadystatechange();
  };
  FakeXHR.prototype.send = function(){
    var kind = match(this._url);
    if (!kind){
      // Fallback to real XHR if not our target
      var real = new OrigXHR();
      var self = this;
      real.open(this._method, this._url);
      real.onreadystatechange = function(){
        self.readyState = real.readyState;
        self.status = real.status;
        self.responseText = real.responseText;
        self.response = real.response;
        if (typeof self.onreadystatechange === 'function') self.onreadystatechange();
        if (real.readyState === 4 && typeof self.onload === 'function') self.onload();
      };
      real.send();
      return;
    }
    var resp = stubResponse(kind);
    var self = this;
    resp.text().then(function(txt){
      self.responseText = txt;
      self.response = txt;
      self.status = 200;
      self.readyState = 4;
      if (typeof self.onreadystatechange === 'function') self.onreadystatechange();
      if (typeof self.onload === 'function') self.onload();
    });
  };
  try {
    window.XMLHttpRequest = FakeXHR;
  } catch(_){}
}();
